import { ArrowUpRight, MessageCircle } from "lucide-react";
import { BRAND, waLink } from "../../lib/brand";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-white"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1656010280162-772358d9f4ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzaWx2ZXIlMjByaW5nJTIwamV3ZWxyeXxlbnwwfHx8fDE3NzczMDc4NjV8MA&ixlib=rb-4.1.0&q=85"
          alt="Silver jewellery macro"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/40 to-white" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_40%,rgba(255,255,255,0.9)_90%)]" />
      </div>
      <div className="relative grain pointer-events-none absolute inset-0" />

      {/* Content */}
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-40 pb-20 lg:pt-48 lg:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <p
              data-testid="hero-overline"
              className="text-[11px] tracking-[0.4em] uppercase text-zinc-500 mb-8 reveal"
            >
              Est. 1972 · Delhi · Traditional Silver Atelier
            </p>
            <h1
              data-testid="hero-title"
              className="font-display font-light text-zinc-950 text-5xl sm:text-7xl lg:text-[96px] leading-[0.98] tracking-tight reveal reveal-delay-1"
            >
              Pure Silver.
              <br />
              <span className="italic text-zinc-700">Timeless</span>{" "}
              Craftsmanship.
            </h1>
            <p
              data-testid="hero-subtitle"
              className="mt-8 max-w-xl text-zinc-600 text-base sm:text-lg leading-relaxed reveal reveal-delay-2"
            >
              Trusted silver jewellers of Chandni Chowk — a quiet family atelier
              shaping anklets, rings, bracelets and temple ornaments in 92.5
              pure silver, for generations of Indian families.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4 reveal reveal-delay-3">
              <a
                href="#collections"
                data-testid="hero-explore-btn"
                className="group inline-flex items-center gap-3 h-14 px-7 bg-zinc-950 text-white text-xs tracking-[0.28em] uppercase hover:bg-white hover:text-zinc-950 border border-zinc-950 transition-colors"
              >
                Explore Collection
                <ArrowUpRight className="h-4 w-4 group-hover:rotate-45 transition-transform" />
              </a>
              <a
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-whatsapp-btn"
                className="inline-flex items-center gap-3 h-14 px-7 border border-zinc-900 text-zinc-900 text-xs tracking-[0.28em] uppercase hover:bg-zinc-950 hover:text-white transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
                Chat on WhatsApp
              </a>
            </div>
          </div>

          {/* Side stats */}
          <div className="lg:col-span-4 lg:pl-10 lg:border-l lg:border-zinc-300/80">
            <div className="grid grid-cols-2 gap-8 reveal reveal-delay-4">
              <div>
                <div className="font-display text-5xl text-zinc-950">1972</div>
                <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                  Established
                </div>
              </div>
              <div>
                <div className="font-display text-5xl text-zinc-950">3+</div>
                <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                  Generations
                </div>
              </div>
              <div>
                <div className="font-display text-5xl text-zinc-950">100%</div>
                <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                  Hand Crafted
                </div>
              </div>
              <div>
                <div className="font-display text-5xl text-zinc-950">92.5</div>
                <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                  Sterling Silver
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trusted marquee */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-zinc-200 bg-white/80 backdrop-blur-sm overflow-hidden">
        <div className="flex marquee-track py-4 whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, i) => (
            <div
              key={i}
              className="flex shrink-0 items-center gap-14 pr-14 text-[11px] tracking-[0.4em] uppercase text-zinc-500"
            >
              <span>◆ Since 1972</span>
              <span>◆ Pure 92.5 Silver</span>
              <span>◆ Handcrafted in Delhi</span>
              <span>◆ Trusted Since Generations</span>
              <span>◆ Traditional Indian Designs</span>
              <span>◆ Personal Attention</span>
              <span>◆ Chandni Chowk Atelier</span>
              <span>◆ Heirloom Quality</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
